// src/pages/PosteCFTV.js
import React from 'react';
import { Helmet } from 'react-helmet';
import './PosteCFTV.css';
import { FaShieldAlt, FaBroadcastTower, FaCloudUploadAlt, FaMobileAlt, FaTools, FaBrain } from 'react-icons/fa';
import ContactForm from '../components/ContactForm';

// Importe as imagens que já temos no projeto para ilustrar
import heroImage from '../assets/intelbras/condominio/poste-cftv.jpg';
import heroBanner from '../assets/intelbras/condominio/banner-poste-cftv.jpg';
import condominioImage from '../assets/banners/Controle-de-acesso-3.jpg';
import comercioImage from '../assets/banners/Camera-Termica-8.jpg';

const PosteCFTV = () => {
    const whatsappNumber = "5511977211739";
    const whatsappMessage = "Olá! Gostaria de saber mais sobre as soluções de Poste CFTV da Primo Trade Solutions.";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(whatsappMessage)}`;

    // --- NOVO: Variável com os dados estruturados para o Google ---
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Instalação de Poste CFTV",
      "serviceType": "Sistema de Segurança CFTV",
      "provider": {
        "@type": "Organization",
        "name": "Primo Trade Solutions",
        "url": "https://www.primotradesolutions.com.br",
        "logo": "https://www.primotradesolutions.com.br/logo.png", // Lembre-se de ter essa imagem na pasta /public
        "telephone": "+55-11-97721-1739"
      },
      "areaServed": {
        "@type": "City",
        "name": "São Paulo"
      },
      "description": "Soluções completas em Poste CFTV para monitoramento de condomínios e empresas com tecnologia Intelbras.",
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Serviços de Poste CFTV"
      }
    };


    return (
        <div className="poste-cftv-page">
            <Helmet>
                <title>Poste CFTV: Segurança Inteligente para Condomínios e Empresas | PTS</title>
                <meta name="description" content="Proteja seu patrimônio com o Poste CFTV da Primo Trade Solutions. Soluções com câmeras Intelbras, monitoramento 24h e acesso remoto. Solicite um orçamento." />
                
                {/* --- NOVO: Script de dados estruturados inserido da forma correta --- */}
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>
            
            {/* --- SEÇÃO 1: HERÓI (NOVO LAYOUT) --- */}
            <section className="cftv-hero-new container">
                {/* 1. Banner Superior */}
                <div className="hero-banner-container">
                    <img src={heroBanner} alt="Banner Poste CFTV Intelbras" className="hero-banner-image" />
                </div>

                {/* 2. Conteúdo Principal (2 Colunas) */}
                <div className="hero-main-content">
                    {/* Coluna da Esquerda: Imagem Quadrada */}
                    <div className="hero-image-column">
                        <img src={heroImage} alt="Poste CFTV da Primo Trade Solutions" className="hero-square-image" />
                    </div>

                    {/* Coluna da Direita: Textos */}
                    <div className="hero-text-column">
                        <h1>Tecnologia e Segurança ao Seu Alcance</h1>
                        <h2>Poste CFTV</h2>
                        <p>Proteja seu condomínio ou comércio com o avançado sistema de monitoramento da Primo Trade Solutions. Imagens de alta definição, armazenamento seguro e monitoramento remoto 24h.</p>
                        <div className="hero-features-new">
                            <span><FaShieldAlt /> Tecnologia de Ponta</span>
                            <span><FaTools /> Instalação Rápida</span>
                            <span><FaBroadcastTower /> Design Discreto</span>
                        </div>
                    </div>
                </div>
            </section>

            {/* ... (todas as outras seções continuam exatamente as mesmas) ... */}

             {/* Seção 2: Como Funciona */}
             <section className="how-it-works">
                <div className="container">
                    <h2>Como Funciona?</h2>
                    <h3>Tecnologia Simples e Eficaz</h3>
                    <div className="steps">
                        <div className="step">
                            <FaBroadcastTower size={50} className="step-icon" />
                            <h4>Câmeras de Alta Resolução</h4>
                            <p>O Poste CFTV utiliza câmeras Intelbras de alta resolução, conectadas a uma central de monitoramento que analisa as imagens em tempo real.</p>
                        </div>
                        <div className="step">
                            <FaCloudUploadAlt size={50} className="step-icon" />
                            <h4>Acesso Remoto via Nuvem</h4>
                            <p>Com a integração à plataforma em nuvem, você pode acessar as gravações de qualquer dispositivo, em qualquer lugar do mundo.</p>
                        </div>
                        <div className="step">
                            <FaMobileAlt size={50} className="step-icon" />
                            <h4>Notificações Imediatas</h4>
                            <p>Em caso de eventos suspeitos, o sistema envia notificações instantâneas para que você possa tomar as medidas necessárias rapidamente.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Seção 3: Benefícios */}
            <section className="benefits">
                <div className="container">
                    <h2>Por que Escolher o Poste CFTV da PTS?</h2>
                    <h3>Benefícios & Diferenciais</h3>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <FaShieldAlt className="benefit-icon" />
                            <h4>Monitoramento 24h</h4>
                            <p>Acompanhe em tempo real o que acontece em seu patrimônio com acesso remoto de qualquer lugar.</p>
                        </div>
                        <div className="benefit-item">
                            <FaMobileAlt className="benefit-icon" />
                            <h4>Ação Imediata</h4>
                            <p>Receba notificações no seu celular em caso de movimento suspeito, permitindo uma resposta rápida.</p>
                        </div>
                        <div className="benefit-item">
                            <FaBroadcastTower className="benefit-icon" />
                            <h4>Proteção Perimetral</h4>
                            <p>Detecte intrusos com sensores de última geração que cobrem todo o perímetro monitorado.</p>
                        </div>
                        <div className="benefit-item">
                            <FaCloudUploadAlt className="benefit-icon" />
                            <h4>Armazenamento Seguro</h4>
                            <p>Imagens armazenadas em nuvem com criptografia avançada, garantindo a proteção dos seus dados.</p>
                        </div>
                        <div className="benefit-item">
                            <FaTools className="benefit-icon" />
                            <h4>Suporte Especializado</h4>
                            <p>Nossa equipe oferece suporte completo, desde a instalação até o acompanhamento contínuo do sistema.</p>
                        </div>
                        <div className="benefit-item">
                            <FaBrain className="benefit-icon" />
                            <h4>Análise com I.A.</h4>
                            <p>Inteligência artificial para identificar atividades suspeitas e reduzir falsos alarmes, com mais precisão.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Seção 4: Aplicações */}
            <section className="applications">
                <div className="container">
                    <h2>Aplicações</h2>
                    <h3>Segurança Sob Medida para Todos os Ambientes</h3>
                    <div className="applications-grid">
                        <div className="application-card">
                            <img src={condominioImage} alt="Segurança para Condomínios" />
                            <div className="application-content">
                                <h4>No Seu Condomínio</h4>
                                <p>Melhore a segurança com um sistema CFTV colaborativo. Moradores podem monitorar áreas comuns e acessar imagens, garantindo um ambiente mais seguro.</p>
                                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="cta-button">
                                    Descubra Mais Aplicações
                                </a>
                            </div>
                        </div>
                        <div className="application-card">
                            <img src={comercioImage} alt="Segurança para Comércio" />
                            <div className="application-content">
                                <h4>No Seu Comércio</h4>
                                <p>Proteja seu negócio com câmeras de alta definição e monitoramento 24h. Ideal para estabelecimentos que desejam manter a segurança e a integridade do local.</p>
                                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="cta-button">
                                    Descubra Mais Aplicações
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            {/* Seção 5: Contato */}
            <section className="contact-section">
                <div className="container">
                    <h2>Não Deixe de Nos Contatar</h2>
                    <p>Nossa equipe de consultores está pronta para ajudá-lo a escolher a melhor solução para suas necessidades.</p>
                    <ContactForm />
                </div>
            </section>

            {/* O <Footer /> foi removido daqui */}
        </div>
    );
};

export default PosteCFTV;